import { CompositeScreenProps } from "@react-navigation/native"
import { observer } from "mobx-react-lite"
import React, { FC, useCallback, useEffect, useState } from "react"
import { Appearance, ViewStyle } from "react-native"
import { JalaLoading, JalaWebView, LazyRender, Screen, Toast } from "../../../../components"
import { translate } from "../../../../i18n"
import { useStores } from "../../../../models"
import { color } from "../../../../theme"
import config from "../../../../utils/config"
import JalaAnalytic from "../../../../utils/jala-analytic"
import { View } from "native-base"
import { goBack } from "../../../../navigators"

const ROOT: ViewStyle = {
  flex: 1,
}

const WEB_VIEW: ViewStyle = {
  flexGrow: 1,
}

const { BASE_URL } = config();

const LoadingState: FC<{ colorScheme: "light"|"dark" }> = function(props) {
  return (
    <View flex={1} px="16px" justifyContent="center" alignItems="center">
      <JalaLoading />
    </View>
  )
}

export const ShrimpNewsDetailScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps <any, any>> = observer(function ShrimpNewsDetailScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), navigation, route } = props
  const { data } = route.params || {};

  // Pull in one of our MST stores
  const { newsStore, newsStore: { cacheToken, error } } = useStores()

  const [uri, setUri] = useState("")

  const getUri = useCallback(() => {
    const URL = `${BASE_URL}/web_view/kabar_udang/`
    // const slug = selectedNews.slug
    const source = `${URL}${data.slug}?cache_key=${cacheToken}`
    setUri(source)
    // return `${URL}${slug}?cache_key=${cacheToken}`
  }, [cacheToken, data.slug])

  const dataToShare = useCallback(() => {
    const title = translate('shareNewsTitle', { news: data.title });
    const message = translate('checkLink', { url: `${BASE_URL}/kabar_udang/${data.slug}` });
    const url = `${BASE_URL}/kabar_udang/${data.slug}`;
    const sharedData = { title, message, post: data, url };
    navigation.setParams({ sharedData });
  }, [data, navigation])

  useEffect(() => {
    newsStore.fetchCacheToken()
  }, [newsStore])

  useEffect(() => {
    if (error) {
      goBack('App.Stack')
      if (!Toast.isActive('CanceledError'))
        Toast.show({ id: 'CanceledError', title: error.message })
      newsStore.set('error', null);
    }
  }, [error, newsStore])

  useEffect(() => {
    getUri()
    dataToShare()
  }, [dataToShare, getUri])

  useEffect(() => {
    const { data = {} } = route.params || {};
    JalaAnalytic.log('Mobile app: post - detail', { data })
  }, [route.params])

  return (
    <Screen
      style={ROOT}
      preset="fixed"
      unsafe
      colorScheme={colorScheme}
      backgroundBar={colorScheme === 'light' ? color.primary : undefined}
      statusBar={colorScheme === 'light' ? 'light-content' : 'dark-content'}
    >
      <LazyRender renderPlaceholder={LoadingState}>
        {uri && <JalaWebView
          source={{ uri }}
          style={WEB_VIEW}
          startInLoadingState
        />}
      </LazyRender>
    </Screen>
  )
})
